import React from 'react';
import PropTypes from 'prop-types';

import AchievementUnlocked from './AchievementUnlocked';
import withModal from '../modal/withModal';

export const ACHIEVEMENT_UNLOCKED_MODAL = 'modal/ACHIEVEMENT_UNLOCKED';

const propTypes = {
  actionProps: PropTypes.shape({
    achievementLevels: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        achievement: PropTypes.shape({
          id: PropTypes.string,
          action: PropTypes.string,
        }),
      }),
    ),
    pendingAchievementLevels: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        achievement: PropTypes.shape({
          id: PropTypes.string,
          action: PropTypes.string,
        }),
      }),
    ),
  }),
  onRequestClose: PropTypes.func,
};

const AchievementUnlockedContainer = ({
  actionProps: { achievementLevels, pendingAchievementLevels } = {},
  onRequestClose,
}) => {
  return (
    <AchievementUnlocked
      achievementLevels={achievementLevels}
      pendingAchievementLevels={pendingAchievementLevels}
      onClose={onRequestClose}
    />
  );
};

AchievementUnlockedContainer.propTypes = propTypes;

export default withModal(AchievementUnlockedContainer, {
  name: ACHIEVEMENT_UNLOCKED_MODAL,
  dismissible: false,
  size: 'sm',
  className: 'achievement-unlocked-modal',
  overlayClassName: 'achievement-unlocked-modal-overlay',
  type: 'full',
});
